export enum VersionForVisuallyImpairedRoutes {
  DataSet = 'dataset',
  Apps = 'apps',
  News = 'news',
  Information = 'information'
}
